import React, { memo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import IconSpinner from "../../shared/icon-spinner";

const PopularMakePills = ({
    brandImage,
    makeCount,
    isPartialSelected,
    isAllFilterSelected,
    onClick,
    brandName
}) => {
    let customStyles = "styles.makePillsWrapper";
    if (isPartialSelected) {
        customStyles = "styles.makePillsWrapper styles.tabActive styles.partialTabActive";
    } else if (isAllFilterSelected) {
        customStyles = "styles.makePillsWrapper styles.tabActive styles.allTabActive";
    }

    const [loading, setLoading] = React.useState(false);

    const handleClick = async (e) => {
        setLoading(true);
        await onClick(e);
        setLoading(false);
    };

    return (
        <div
            styleName={customStyles}
            onClick={handleClick}
        >
            {
                loading ? (
                    <div styleName={"styles.outerBtn"}>
                        <IconSpinner />
                    </div>
                ) : (
                    <React.Fragment>
                        <div styleName={"styles.imageWrapper"}>
                            <img src={brandImage} alt={brandName} loading="lazy" />
                        </div>
                        <p styleName={"styles.makeCount"}>({makeCount})</p>
                    </React.Fragment>
                )
            }

        </div>
    );
};

PopularMakePills.propTypes = {
    isPartialSelected: PropTypes.bool,
    isAllFilterSelected: PropTypes.bool,
    brandImage: PropTypes.string,
    makeCount: PropTypes.number,
    onClick: PropTypes.func,
    brandName: PropTypes.string
};

export default memo(PopularMakePills);
